module.exports = __webpack_public_path__ + "img/dhfesta_productInfo_0421.4527cea4.jpg";